export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5255.31adb5c0.jpg";